import { DEFAULT_LOCALE, Locale, languages } from 'languages';

// Locales with translations; the default one is served un-prefixed.
export const URL_LOCALES: string[] = Object.keys(languages).reduce(
  (acc, country) => acc.concat(languages[country].map(({ locale }) => locale)),
  [] as string[]
);

// `fr` has URLs but no hreflang: France is a blocked country, nothing to target.
export const HREFLANG_LOCALES = URL_LOCALES.filter(
  (locale) => locale !== Locale.FRENCH
);

// Case-insensitive, returns the canonical code (`en-ca` → `en-CA`).
export const findUrlLocale = (value?: string): string | undefined =>
  value
    ? URL_LOCALES.find((locale) => locale.toLowerCase() === value.toLowerCase())
    : undefined;

export const getLocaleFromPath = (pathname: string): string | undefined =>
  findUrlLocale(pathname.split('/')[1]);

export const stripLocaleFromPath = (pathname: string): string => {
  const segments = pathname.split('/');
  if (!findUrlLocale(segments[1])) return pathname;

  const rest = segments.slice(2).join('/');
  return rest ? `/${rest}` : '/';
};

// `/` → `/de/` on purpose: CMS SEO entries and sitemaps use the trailing slash.
export const addLocaleToPath = (path: string, locale: string): string => {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  if (locale === DEFAULT_LOCALE || !findUrlLocale(locale)) {
    return normalizedPath;
  }

  return `/${locale}${normalizedPath}`;
};

export const getLocaleBasename = (locale: string): string =>
  locale === DEFAULT_LOCALE ? '' : `/${locale}`;
